import { Action } from 'redux';

export interface BrowserDetailsAction extends Action {
  readonly isScreenSize768?: boolean;
}

export interface BrowserDetails {
  isScreenSize768: boolean;
}

const initialState = {
  isScreenSize768: false,
} as BrowserDetails;

enum Actions {
  IS_SCREEN_SIZE_768 = 'IS_SCREEN_SIZE_768',
}

const setIsScreenSize768 = (
  isScreenSize768: boolean,
): BrowserDetailsAction => ({
  type: Actions.IS_SCREEN_SIZE_768,
  isScreenSize768,
});

const browserDeatilsReducer = (
  state = initialState,
  action: BrowserDetailsAction,
) => {
  switch (action.type) {
    case Actions.IS_SCREEN_SIZE_768:
      return {
        ...state,
        isScreenSize768: action.isScreenSize768,
      };
    default:
      return state;
  }
};

export { browserDeatilsReducer, setIsScreenSize768 };
